<template>
	<div>
		<div class="button-wrapper">
			<button
				:class="getButtonClass"
				:disabled="isButtonDisabled || isLoading"
				@click="handleClick"
				:type="buttonType"
			>
				<span
					v-if="isLoading"
					class="fa fa-spinner fa-spin"
				></span>
				<span v-else>{{ buttonText }}</span>
			</button>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed, ref, toRefs } from 'vue';

	export interface IButtonProps {
		buttonText: string;
		clickAction?: () => void;
		isButtonDisabled?: boolean;
		isLoading?: boolean;
		buttonType?: 'button' | 'submit' | 'reset';
		loadingText?: string;
	}

	const props = defineProps<IButtonProps>();
	const { buttonText, clickAction, isButtonDisabled, buttonType, isLoading } = toRefs(props);

	const getButtonClass = computed((): string => {
		if (isButtonDisabled.value) return 'primary-button-disabled';
		return 'primary-button';
	});

	const handleClick = () => clickAction.value();
</script>
<style>
	.primary-button {
		width: 100%;
		background-color: var(--customer-portal-primary-color) !important;
		border: none;
		color: var(--customer-portal-white-color);
		padding: 10px 10px;
		text-align: center;
		text-decoration: none;
		display: inline-block;
		margin: 4px 2px;
		cursor: pointer;
		border-radius: 16px;
		font-size: clamp(12px, 3vw, 14px);
	}

	.primary-button-disabled {
		width: 100%;
		background-color: none !important;
		border: none;
		color: var(--customer-portal-white-color);
		padding: 10px 10px;
		text-align: center;
		text-decoration: none;
		display: inline-block;
		margin: 4px 2px;
		cursor: not-allowed;
		border-radius: 16px;
		font-size: clamp(12px, 3vw, 14px);
	}

	.button-wrapper {
		display: flex;
		justify-content: flex-end;
	}
</style>
